import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInfoSummaryWidgetStyles = isSmallScreen => {
  return StyleSheet.create({
    buttonWidgetContainer: {
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingBottom: tokens.spacing.SPACING_16
    },
    marginBottom16: {
      marginBottom: tokens.spacing.SPACING_16
    },
    infoItemButtonWidgetContainer: {
      marginTop: tokens.spacing.SPACING_8,
      marginBottom: tokens.spacing.SPACING_16
    },
    container: {
      maxWidth: isSmallScreen ? tokens.spacing.SPACING_335 : tokens.spacing.SPACING_442
    },
    singleCardWrapper: {
      paddingTop: tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_16,
      width: '100%'
    },
    collapsibleCardWrapper: {
      paddingHorizontal: tokens.spacing.SPACING_16,
      width: '100%'
    },
    headerWrapperBottomRow: {
      marginVertical: tokens.spacing.SPACING_4
    },
    headerWrapperRowOne: {
      marginBottom: tokens.spacing.SPACING_8
    },
    headerWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    },
    headerOneInfoWrapper: {
      marginRight: tokens.spacing.SPACING_8,
      justifyContent: 'center'
    },
    singleBlockDetailsContainerBorderAddition: {
      flex: 1,
      marginRight: tokens.spacing.SPACING_4,
      paddingRight: tokens.spacing.SPACING_4
    },
    rowDataWrapper: {
      width: '100%',
      justifyContent: 'space-between'
    },
    detailsContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    calloutWidgetWrapper: {
      marginBottom: tokens.spacing.SPACING_16
    },
    planInfoWidgetWrapper: {
      marginTop: tokens.spacing.SPACING_8,
      marginVertical: tokens.spacing.SPACING_8
    },
    titleTextIconWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    titleTextContainer: {
      marginRight: tokens.spacing.SPACING_4
    },
    headerTextWrapper: {
      flex: 1
    }
  });
};